var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "container mt-5"
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('b-card', [_c('div', {
    staticClass: "text-center mt-2"
  }, [_c('h1', {
    staticClass: "h5 font-weight-bold"
  }, [_vm._v("點選下方按鈕綁定業務")])]), _c('div', {
    staticClass: "d-flex justify-content-between",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": function click() {
        return _vm.goto();
      }
    }
  }, [_vm._v("前往綁定")])], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }